const STAGGER_MS = 60;

function markTargets(main) {
  const sections = main.querySelectorAll(':scope > .shopify-section');
  sections.forEach((section) => {
    section.setAttribute('data-scroll-reveal', '');

    const cards = section.querySelectorAll('.resource-list__item');
    cards.forEach((card, index) => {
      card.setAttribute('data-scroll-reveal', '');
      card.style.transitionDelay = `${Math.min(index, 8) * STAGGER_MS}ms`;
    });
  });
}

function observe(main) {
  const targets = main.querySelectorAll('[data-scroll-reveal]');
  if (!targets.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach((target) => observer.observe(target));
}

function init() {
  const main = document.querySelector('#MainContent[data-template="index"]');
  if (!main) return;

  markTargets(main);
  observe(main);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
